<template>
    <div>
        <div class="Panel" v-show="hasUnapprovedUsers">
            <div class="Panel__heading">Un-Approved Users</div>
            <div class="Panel__body">
                <div class="TableResponsive" style="padding-bottom: 75px">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th>Member Name</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in unapprovedUsers">
                            <td style="width: 250px;">
                                <multiselect v-model="user.member"
                                             :value="user.member"
                                             track-by="id"
                                             label="number_name"
                                             :options="members"
                                             :multiple="false"
                                             :hide-selected="false"
                                             :close-on-select="true"
                                             :options-limit="99999999999"
                                             :max-height="75"
                                             placeholder="Select Member"
                                             @input="updateUserFields(user)"
                                >
                                </multiselect>
                            </td>

                            <td class="Table__cell--form-field">
                                <input type="text" class="Form__text" v-model.trim="user.name">
                            </td>

                            <td class="Table__cell--form-field">
                                <input type="text" class="Form__text" v-model.trim="user.email">
                            </td>

                            <td class="Table__cell--form-field" style="width: 250px;">
                                <div class="Form__select">
                                    <select v-model="user.roles[0].id">
                                        <option :value="option.id"
                                                v-for="option in roles"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="deleteUser(user.id)"
                                >
                                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success"
                                   @click.prevent="approveUser(user)"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="Panel">
            <div class="Panel__heading">Approved Users</div>
            <div class="Panel__body">
                <div class="row">
                    <div class="col-md-9">
                        <a href="/system-settings/account-management/users/export" class="Button">Export</a>
                    </div>
                    <div class="col-md-3">
                        <input type="text"
                               class="Form__text"
                               placeholder="Search by name, email, member name or number..."
                               v-model.trim="search"
                               @keyup="pagination.currentPage = 1"
                        >
                    </div>
                </div>
                <div class="TableResponsive" style="padding-bottom: 75px">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th>Member No.</th>
                            <th>Member Name</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th></th>
                            <th></th>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <multiselect v-model="newUser.member_id"
                                             track-by="id"
                                             label="number_name"
                                             :options="members"
                                             :multiple="false"
                                             :hide-selected="false"
                                             :close-on-select="true"
                                             :options-limit="99999999999"
                                             placeholder="Select Member"
                                >
                                </multiselect>
                            </td>
                            <td>
                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="newUser.name"
                                       @keyup.enter="createUser"
                                >
                                <div class="Form__error">{{ newUserNameError }}</div>
                            </td>
                            <td>
                                <input type="email"
                                       class="Form__text"
                                       v-model.trim="newUser.email"
                                       @keyup.enter="createUser"
                                >
                                <div class="Form__error">{{ newUserEmailError }}</div>
                            </td>
                            <td>
                                <div class="Form__select">
                                    <select v-model="newUser.role_id">
                                        <option :value="option.id"
                                                v-for="option in roles"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger Table__control--create"
                                   @click.prevent="clearNewUser"
                                >
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success Table__control--create"
                                   @click.prevent="createUser"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in paginatedApprovedUsers">
                            <template v-if="isBeingEdited(user.id)">
                                <td colspan="2">
                                    <multiselect v-model="editing[user.id].member"
                                                 :value="user.member"
                                                 track-by="id"
                                                 label="number_name"
                                                 :options="members"
                                                 :multiple="false"
                                                 :hide-selected="false"
                                                 :close-on-select="true"
                                                 :options-limit="99999999999"
                                                 :allow-empty="false"
                                                 placeholder="Select Member"
                                                 :max-height="75"
                                                 @input="updateUserFields(editing[user.id])"
                                    >
                                    </multiselect>
                                </td>
                            </template>
                            <template v-else>
                                <td class="Table__cell--min-width">{{ user.member_number }}</td>
                                <td class="Table__cell--form-field" style="width: 250px;">{{ user.member_name }}</td>
                            </template>
                            <td class="Table__cell--form-field">
                                <input type="text"
                                       class="Form__text"
                                       v-if="isBeingEdited(user.id)"
                                       v-model.trim="editing[user.id].name"
                                       @keyup.enter="updateUser(editing[user.id])"
                                >

                                <span v-else>{{ user.name }}</span>
                            </td>
                            <td class="Table__cell--form-field">
                                <input type="email"
                                       class="Form__text"
                                       v-if="isBeingEdited(user.id)"
                                       v-model.trim="editing[user.id].email"
                                       @keyup.enter="updateUser(editing[user.id])"
                                >

                                <span v-else>{{ user.email }}</span>
                            </td>
                            <td class="Table__cell--form-field" style="width: 250px;">
                                <div class="Form__select" v-if="isBeingEdited(user.id)">
                                    <select v-model="editing[user.id].roles[0].id">
                                        <option :value="option.id"
                                                v-for="option in roles"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                <span v-else>{{ currentRole(user) }}</span>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="endEdit(user.id)"
                                   v-if="isBeingEdited(user.id)"
                                >
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="deleteUser(user.id)"
                                   v-else
                                >
                                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success"
                                   @click.prevent="updateUser(editing[user.id])"
                                   v-if="isBeingEdited(user.id)"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--primary"
                                   @click.prevent="editUser(user)"
                                   v-else
                                >
                                    <i class="fa fa-pencil fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="Pagination" v-show="pages > 1">
                    <ul class="Utility__list-inline">
                        <li class="Pagination__page">
                            <a href="#" @click.prevent="showFirstPage">
                                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                            </a>
                        </li><li :class="pageClasses(page)" v-for="page in pageLinks">
                            <a href="#" @click.prevent="showPage(page)">{{ page }}</a>
                        </li><li class="Pagination__page">
                            <a href="#" @click.prevent="showLastPage">
                                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Pagination from './../mixins/pagination';

    export default {
        data() {
            return {
                newUser: {
                    member_id: '',
                    name: '',
                    email: '',
                    role_id: '',
                },
                newUserNameError: '',
                newUserEmailError: '',
                roles: [],
                users: [],
                members: [],
                editing: {},
                search: '',
            }
        },

        mixins: [Pagination],

        props: {
            currentUsers: {
                required: true
            },

            currentMembers: {
                required: true,
            },

            availableRoles: {
                required: true
            }
        },

        mounted() {
            this.users = JSON.parse(this.currentUsers);
            this.roles = JSON.parse(this.availableRoles);
            this.members = JSON.parse(this.currentMembers);
            this.newUser.member_id = this.members[0].id;
            this.newUser.role_id = this.roles[0].id;
        },

        computed: {
            approvedUsers() {
                return _.chain(this.users)
                    .sortBy(user => {
                        return user.member_name.toLowerCase();
                    }).filter(user => {
                        if (this.search) {
                            let regex = RegExp(this.search, 'i');

                            return user.approved == 1 && (
                                user.name.match(regex) ||
                                user.email.match(regex) ||
                                user.member_name.match(regex) ||
                                user.member.membership_number.match(regex)
                            );
                        }

                        return user.approved == 1
                    }).value();
            },

            pages() {
                return Math.ceil(this.approvedUsers.length / this.pagination.perPage);
            },

            paginatedApprovedUsers() {
                return this.approvedUsers.slice(this.currentPageStart, this.currentPageEnd);
            },

            unapprovedUsers() {
                return _.filter(this.users, (user) => {
                    return user.approved == 0;
                });
            },

            hasUnapprovedUsers() {
                return ! _.isEmpty(this.unapprovedUsers);
            }
        },

        methods: {
            approveUser(user) {
                this.$http.post('/system-settings/account-management/users/approve', {
                    id: user.id,
                    member_id: user.member_id,
                    name: user.name,
                    email: user.email,
                    role_id: user.roles[0].id
                }).then((response) => {
                    user.approved = 1;
                });
            },

            updateUser(user) {
                if (user.name == '') {
                    this.endEdit(user.id);
                }

                this.$http.patch('/system-settings/account-management/users/' + user.id, {
                    member_id: user.member_id,
                    name: user.name,
                    email: user.email,
                    role_id: user.roles[0].id,
                }).then(() => {
                    let u = _.find(this.users, ['id', user.id]);

                    u.member_id = user.member_id;
                    u.member_name = user.member_name;
                    u.member_number = user.member_number;
                    u.name = user.name;
                    u.email = user.email;
                    u.member = user.member;

                    if (! _.isEmpty(u.roles)) {
                        u.roles[0].id = user.roles[0].id;
                    } else {
                        u.roles.push({ id: user.roles[0].id });
                    }

                    this.endEdit(user.id);
                })
            },

            deleteUser(id) {
                this.$http.delete('/system-settings/account-management/users/' + id).then((response) => {
                    this.users = _.reject(this.users, (user) => {
                        return user.id == id;
                    })
                })
            },

            updateUserFields(user) {
                user.member_name = user.member.name;
                user.member_id = user.member.id;
                user.member_number = user.member.membership_number;

                this.$forceUpdate();
            },

            editUser(user) {
                let clonedUser = _.cloneDeep(user);

                if (_.isEmpty(clonedUser.roles)) {
                    clonedUser.roles.push({ id: '' });
                }

                _.set(this.editing, user.id, _.cloneDeep(clonedUser));

                this.$forceUpdate();
            },

            endEdit(id) {
                _.unset(this.editing, id);

                this.$forceUpdate();
            },

            isBeingEdited(id) {
                return _.has(this.editing, id);
            },

            currentRole(user) {
                let role = _.find(this.roles, (role) => {
                    if (! user.roles[0]) return false;

                    return role.id == user.roles[0].id;
                })

                return role ? role.label : '';
            },

            createUser() {
                this.newUserNameError = '';
                this.newUserEmailError = '';

                if (this.newUser.name == '') {
                    return this.newUserNameError = 'User Name is required';
                }

                if (this.newUser.email == '') {
                    return this.newUserEmailError = 'User Email is required';
                }

                this.$http.post('/system-settings/account-management/users', this.newUser)
                    .then((response) => {
                        this.clearNewUser()

                        this.users.push(response.data);

                        this.$forceUpdate();
                    }).catch((error) => {
                        this.newUserEmailError = error.response.data.email[0];
                    }
                );
            },

            clearNewUser() {
                this.newUser.member_id = this.members[0].id;
                this.newUser.name = '';
                this.newUser.email = '';
                this.newUser.role_id = this.roles[0].id;
                this.newUserNameError = '';
                this.newUserEmailError = '';
            },
        },

        components: {
            Multiselect,
        },
    }
</script>